import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=d6c44ca4&"
import script from "./PlaceAdd.vue?vue&type=script&lang=js&"
export * from "./PlaceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports